'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  twitter: function twitter() {
    var link = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return 'https://twitter.com/intent/tweet/?text=' + encodeURIComponent(message) + '&url=' + encodeURIComponent(link);
  },
  facebook: function facebook() {
    var link = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return 'https://facebook.com/sharer/sharer.php?u=' + encodeURIComponent(link);
  },
  google: function google() {
    var link = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return 'https://plus.google.com/share?url=' + encodeURIComponent(link);
  },
  tumblr: function tumblr() {
    var link = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return 'http://tumblr.com/widgets/share/tool?canonicalUrl=' + encodeURIComponent(link);
  },
  reddit: function reddit() {
    var link = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return 'https://reddit.com/submit/?url=' + encodeURIComponent(link) + '&title=' + encodeURIComponent(message);
  },
  whatsapp: function whatsapp() {
    var link = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return 'https://api.whatsapp.com/send?text=' + encodeURIComponent(message) + '%20' + encodeURIComponent(link);
  },
  telegram: function telegram() {
    var link = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return 'https://telegram.me/share/url?text=' + encodeURIComponent(message) + '&url=' + encodeURIComponent(link);
  },
  vk: function vk() {
    var link = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return 'http://vk.com/share.php?title=' + encodeURIComponent(message) + '&url=' + encodeURIComponent(link);
  },
  hacker: function hacker() {
    var link = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return 'https://news.ycombinator.com/submitlink?u=' + encodeURIComponent(link) + '&t=' + encodeURIComponent(message);
  },
  xing: function xing() {
    var link = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return 'https://www.xing.com/app/user?op=share;url=' + encodeURIComponent(link) + ';title=' + encodeURIComponent(message) + '.';
  },
  mail: function mail() {
    var link = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var subject = arguments[1];
    var body = arguments[2];
    return 'mailto:?subject=' + encodeURIComponent(subject || '') + '&body=' + encodeURIComponent(body && body + '\n\n' + link || link);
  },
  pinterest: function pinterest() {
    var link = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return 'https://pinterest.com/pin/create/button/?url=' + encodeURIComponent(link) + '&media=' + encodeURIComponent(link) + '&description=' + encodeURIComponent(message);
  },
  linkedin: function linkedin() {
    var link = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return 'https://www.linkedin.com/sharing/share-offsite/?url=' + encodeURIComponent(link);
  }
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-social-sharing/dist-modules/consts.js
 ** module id = 65
 ** module chunks = 0
 **/